import React, { useRef } from 'react'
import DashboardMessages from '../../layers/messages/dashboard'
import PingMessages from '../../layers/messages/ping'
import OptInMessages from '../../layers/messages/opt-in'
import ResizeMessages from '../../layers/messages/resize'
import PreviewMessages from '../../layers/messages/preview'
import Provider from '../../layers/messages/provider'

type Children = { children: React.ReactNode }
const Messages = ({ children }: Children) => {
  const widgetRef = useRef<HTMLIFrameElement | null>(null)

  return (
    <Provider widgetRef={widgetRef}>
      <DashboardMessages>
        <PingMessages>
          <OptInMessages>
            <ResizeMessages>
              <PreviewMessages>{children}</PreviewMessages>
            </ResizeMessages>
          </OptInMessages>
        </PingMessages>
      </DashboardMessages>
    </Provider>
  )
}
export default Messages
